import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Loader from '../BlueButton/Loader.js';
import {word} from "../../word.js";

const CustomDropdown = ({ item, index, form, setForm, submitted, keyPress, word, options }) => {
    const handleChange = (value) => {
        const updatedForm = [...form];
        updatedForm[index].active = false;

        if (item.key === "repeated_type") {
            const selectedValue = value ? value.value : "";
            updatedForm[index].value = selectedValue;
            updatedForm[index].valid = [1, 2, 3, 4].includes(selectedValue);

            if (selectedValue === 1 && updatedForm[index + 1]) {
                updatedForm[index + 1].valid = true;
            }
        } else {
            const selectedUrl = value ? value.url : "";
            updatedForm[index].value = selectedUrl;
            updatedForm[index].valid = selectedUrl.length > 0;
        }

        setForm(updatedForm);
    };

    const wrapperClass = !item.valid && submitted
        ? "input-validation input-validation-valid"
        : "input-validation";

    const commonProps = {
        onChange: (e, value) => handleChange(value),
        onKeyDown: (e) => keyPress(e),
        renderInput: (params) => (
            <TextField
                {...params}
                label={word[item.key]}
                error={!item.valid && submitted}
                id={!item.valid && submitted ? "validation-outlined-input" : "outlined-helperText"}
                variant="outlined"
                fullWidth
            />
        ),
    };

    const renderValidationError = () =>
        !item.valid && submitted && (
            <div className="validation valid-center">{word[item.errorMessage]}</div>
        );

    let dropdownOptions = options[item.option] || [];
    if (item.key === "manager" || item.key === "accountant") {
        dropdownOptions = dropdownOptions.filter(el => el.user?.is_active);
        return (
            <div key={index} className={wrapperClass}>
                <Autocomplete
                    id="combo-box-demo"
                    options={dropdownOptions}
                    getOptionKey={(option) => option.id}

                    getOptionLabel={(option) => `${option.user.first_name} ${option.user.last_name}`}
                    filterOptions={(opts, params) =>
                        opts.filter(opt =>
                            opt.user.first_name.toUpperCase().includes(params.inputValue.toUpperCase()) ||
                            opt.user.last_name.toUpperCase().includes(params.inputValue.toUpperCase())
                        )
                    }
                    {...commonProps}
                />
                {renderValidationError()}
            </div>
        );
    }

    if (item.key === "repeated_type") {
        return (
            <div key={index} className={wrapperClass}>
                <Autocomplete
                    id="combo-box-demo"
                    options={item.option}
                    getOptionKey={(option) => option.id}

                    getOptionLabel={(option) => word[option.name]}
                    {...commonProps}
                />
                {renderValidationError()}
            </div>
        );
    }

    return (
        <div key={index} className={wrapperClass}>
            <Autocomplete
                id="combo-box-demo"
                options={dropdownOptions}
                loading={!dropdownOptions.length}
                getOptionKey={(option) => option.id}

                loadingText={
                    <div className="auto-complete-loader">
                        <Loader type="Oval" color="#101C2A" height={20} width={20} />
                    </div>
                }
                getOptionLabel={(option) => option.name}
                {...commonProps}
            />
            {renderValidationError()}
        </div>
    );
};

export default CustomDropdown;
